module.exports = {
	"apiKey": "AIzaSyDfCa5Fq2SWF1HAJjdy_cUyPKur-muhgXU",
	"authDomain": "payday-4dbd5.firebaseapp.com",
	"databaseURL": "https://payday-4dbd5.firebaseio.com",
	"storageBucket": "payday-4dbd5.appspot.com",
	"messagingSenderId": "821888130932"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/firebase.json
// module id = 682
// module chunks = 0